let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a9Cjn")).then(() => parcelRequire('8Cbid'));